import { Component, OnInit, AfterViewInit, OnChanges, Input, Output, EventEmitter, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { HttpService } from '../../../services/http.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-table',
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.scss']
})
export class TableComponent implements OnInit, AfterViewInit, OnChanges {

  @Input() data: any[];
  @Input() keyword: String;
  @Input() id: string;
  @Input() maxSize: number;
  @Input() lang: string;
  @Output() pageChange: EventEmitter<number>;
  @Output() kw = new EventEmitter();

  result = [];
  times = [];
  array = [];
  newArea = [];
  p = 1;
  langPagination = '';
  isSort = false;
  isUpDown = false;
  sortText = 'Number';
  sortType = 'number';
  upDown = 1;

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private translate: TranslateService
  ) { }

  ngOnInit() {
    if (isPlatformBrowser(this.platformId)) {
      if (sessionStorage.getItem('survey-list')) {
        const survey = sessionStorage.getItem('survey-list');
        this.data = JSON.parse(survey);
      }
      this.changeArray(this.data);
      if (sessionStorage.getItem('page')) {
        this.p = parseInt(sessionStorage.getItem('page'), 0);
      }
      window.addEventListener('click', () => {
        for (let i = 0; i < document.getElementsByClassName('sort-by').length; i++) {
          if (event.target !== document.getElementsByClassName('sort-by')[i].children[0]
            && event.target !== document.getElementsByClassName('up-down')[0].children[0]) {
            this.isSort = false;
            this.isUpDown = false;
          }
        }
      });
      if (sessionStorage.getItem('keyword') !== '') {
        this.kw.emit(sessionStorage.getItem('keyword'));
      }
    }
  }

  ngAfterViewInit() {
    if (isPlatformBrowser(this.platformId)) {
      sessionStorage.removeItem('page');
      sessionStorage.removeItem('survey-list');
      sessionStorage.setItem('keyword', '');
    }
  }

  ngOnChanges() {
    if (isPlatformBrowser(this.platformId)) {
      if (!sessionStorage.getItem('sort-type')) {
        sessionStorage.setItem('sort-type', this.sortType);
      } else {
        this.sortType = sessionStorage.getItem('sort-type');
      }
      if (!sessionStorage.getItem('sort-text')) {
        sessionStorage.setItem('sort-text', this.sortText);
      } else {
        this.sortText = sessionStorage.getItem('sort-text');
      }
      if (!sessionStorage.getItem('up-down')) {
        sessionStorage.setItem('up-down', this.upDown.toString());
      } else {
        this.upDown = parseInt(sessionStorage.getItem('up-down'), 0);
      }
      if (this.keyword === '' && sessionStorage.getItem('keyword') !== '') {
        this.keyword = sessionStorage.getItem('keyword');
      }
    }
    this.filterAreas(this.array, this.keyword, this.sortType, this.upDown);
    this.translate.get('of').subscribe((res: string) => {
      this.langPagination = res;
    });
  }

  changeArray(arrayChange) {
    this.array = [];
    arrayChange.forEach((areas) => {
      areas.areas.forEach(area => {
        area.noise_status = (area.noise_status.charAt(0).toUpperCase() + area.noise_status.slice(1)).trim();
        this.array.push(area);
      });
    });
    this.array.forEach((color) => {
      if (color.noise_eq <= 35) {
        color.color = 'color-legend01';
      } else if (color.noise_eq > 35 && color.noise_eq <= 40) {
        color.color = 'color-legend02';
      } else if (color.noise_eq > 40 && color.noise_eq <= 45) {
        color.color = 'color-legend03';
      } else if (color.noise_eq > 45 && color.noise_eq <= 50) {
        color.color = 'color-legend04';
      } else if (color.noise_eq > 50 && color.noise_eq <= 55) {
        color.color = 'color-legend05';
      } else if (color.noise_eq > 55 && color.noise_eq <= 60) {
        color.color = 'color-legend06';
      } else if (color.noise_eq > 60 && color.noise_eq <= 65) {
        color.color = 'color-legend07';
      } else if (color.noise_eq > 65 && color.noise_eq <= 70) {
        color.color = 'color-legend08';
      } else if (color.noise_eq > 70 && color.noise_eq <= 75) {
        color.color = 'color-legend09';
      } else if (color.noise_eq > 75) {
        color.color = 'color-legend10';
      }
    });
    this.newArea = arrayChange;
    this.filterAreas(this.array, this.keyword, this.sortType, this.upDown);
  }

  filterAreas(list, keyword, sortType, upDown) {
    this.p = 1;
    const order = upDown === 1;
    if (sortType === 'noise-level') {
      if (order) {
        list.sort(function (a, b) { return (b.noise_eq > a.noise_eq) ? 1 : -1; });
      } else {
        list.sort(function (a, b) { return (a.noise_eq > b.noise_eq) ? 1 : -1; });
      }
    } else if (sortType === 'city') {
      if (order) {
        list.sort(function (a, b) {
          if (a.city !== b.city) {
            return b.city.localeCompare(a.city);
          } else {
            return (b.id > a.id) ? 1 : -1;
          }
        });
      } else {
        list.sort(function (a, b) {
          if (a.city !== b.city) {
            return a.city.localeCompare(b.city);
          } else {
            return (a.id > b.id) ? 1 : -1;
          }
        });
      }
    } else if (sortType === 'number') {
      if (order) {
        list.sort(function (a, b) { return (b.id > a.id) ? 1 : -1; });
      } else {
        list.sort(function (a, b) { return (a.id > b.id) ? 1 : -1; });
      }
    }
    if (!keyword) {
      keyword = '';
    }
    this.result = list.filter(item => item.address.toLowerCase().indexOf(keyword.toLowerCase()) !== -1
      || item.name.toLowerCase().indexOf(keyword.toLowerCase()) !== -1
      || item.noise_status.toLowerCase().indexOf(keyword.toLowerCase()) !== -1);
    let newTime, weekday, time, date;
    for (let i = 0; i < this.result.length; i++) {
      newTime = new Date(this.result[i].time * 1000);
      if (isPlatformBrowser(this.platformId)) {
        const optionsWeek = {
          timeZone: this.result[i].timezone,
          weekday: 'long'
        };
        weekday = new Intl.DateTimeFormat(this.lang, optionsWeek).format(newTime);
        const optionsDate = {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          timeZone: this.result[i].timezone
        };
        newTime = new Intl.DateTimeFormat('en', optionsDate).format(newTime);
        time = newTime.split(', ')[1];
        date = newTime.split(', ')[0];
        this.result[i].textTime = weekday + ' ' + time + ' ' + date;
      }
    }
  }

  filterArray(event) {
    this.changeArray(event);
  }

  savePage(id) {
    if (isPlatformBrowser(this.platformId)) {
      sessionStorage.setItem('page', this.p.toString());
      let newArea;
      newArea = this.array.filter(item => item.id === id)[0];
      sessionStorage.setItem('keyword', this.keyword.toString());
      sessionStorage.setItem('current',
        '{ "center": { "lat": "' +
        newArea.latitude + '", "lng": "' + newArea.longitude + '" }, "zoom": ' + 18 + ' }'
      );
      sessionStorage.setItem('survey', JSON.stringify(this.newArea));
      sessionStorage.setItem('survey-list', JSON.stringify(this.newArea));
    }
  }

  scrollTop() {
    if (isPlatformBrowser(this.platformId)) {
      document.getElementsByClassName('scroll-box')[0].scrollTop = 0;
    }
  }

  toggleSort() {
    this.isUpDown = false;
    this.isSort = !this.isSort;
  }

  toggleUpdown() {
    this.isSort = false;
    this.isUpDown = !this.isUpDown;
  }

  sortNoiseLevel() {
    this.sortType = 'noise-level';
    this.sortText = 'Noise levels';
    this.filterAreas(this.array, this.keyword, this.sortType, this.upDown);
    if (isPlatformBrowser(this.platformId)) {
      sessionStorage.setItem('sort-type', this.sortType);
      sessionStorage.setItem('sort-text', this.sortText);
    }
  }

  sortCity() {
    this.sortType = 'city';
    this.sortText = 'City';
    this.filterAreas(this.array, this.keyword, this.sortType, this.upDown);
    if (isPlatformBrowser(this.platformId)) {
      sessionStorage.setItem('sort-type', this.sortType);
      sessionStorage.setItem('sort-text', this.sortText);
    }
  }

  sortNumber() {
    this.sortType = 'number';
    this.sortText = 'Number';
    this.filterAreas(this.array, this.keyword, this.sortType, this.upDown);
    if (isPlatformBrowser(this.platformId)) {
      sessionStorage.setItem('sort-type', this.sortType);
      sessionStorage.setItem('sort-text', this.sortText);
    }
  }

  ascending() {
    this.upDown = 0;
    this.filterAreas(this.array, this.keyword, this.sortType, this.upDown);
    if (isPlatformBrowser(this.platformId)) {
      sessionStorage.setItem('up-down', this.upDown.toString());
    }
  }

  descending() {
    this.upDown = 1;
    this.filterAreas(this.array, this.keyword, this.sortType, this.upDown);
    if (isPlatformBrowser(this.platformId)) {
      sessionStorage.setItem('up-down', this.upDown.toString());
    }
  }

}
